<template>
  <v-container>
    <v-row class="mb-4" align="center" justify="space-between">
      <h2>ACL – Policy Utente</h2>
      <v-btn color="primary" @click="newPolicy">Nuova Policy</v-btn>
    </v-row>

    <v-data-table :headers="headers" :items="policies" dense>
      <template v-slot:item.condition="{ item }">
        <pre class="ma-0">{{ pretty(item.condition) }}</pre>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn small text @click="edit(item)">Modifica</v-btn>
        <v-btn small text color="red" @click="remove(item)">Elimina</v-btn>
      </template>
    </v-data-table>

    <v-divider class="my-6"></v-divider>

    <h3>{{ form.id ? 'Modifica' : 'Nuova' }} Policy</h3>
    <v-form ref="f" v-model="valid">
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field v-model="form.user_id" label="User ID" type="number" :rules="[v=>!!v||'Richiesto']"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field v-model="form.action" label="Action" placeholder="view" />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field v-model="form.resource" label="Resource" placeholder="candidato/contatto" />
        </v-col>
        <v-col cols="12" md="2">
          <v-select :items="['allow','deny']" v-model="form.effect" label="Effect" />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field v-model="form.priority" type="number" label="Priority" />
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="conditionJSON" label="Condition (JSON)"
            hint='Esempio: {"fase":{"$in":["formazione","offerta"]}}' persistent-hint auto-grow />
        </v-col>
        <v-col cols="12">
          <v-btn :disabled="!valid" color="primary" @click="save">Salva</v-btn>
          <v-btn text @click="reset">Reset</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="my-6"></v-divider>
    <h3>Tester</h3>
    <v-row>
      <v-col cols="12" md="2"><v-text-field v-model="test.action" label="Action"/></v-col>
      <v-col cols="12" md="2"><v-text-field v-model="test.resource" label="Resource"/></v-col>
      <v-col cols="12" md="8">
        <v-textarea v-model="testAttrsJSON" label="Attrs (JSON)" auto-grow />
      </v-col>
      <v-col cols="12">
        <v-btn color="secondary" @click="runTest">Valuta</v-btn>
        <span class="ml-4" :class="testResult ? 'green--text' : 'red--text'">
          {{ testResult === null ? '' : (testResult ? 'ALLOW' : 'DENY') }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { evaluate } from '@/acl';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  data: () => ({
    headers: [
      { text: 'ID', value: 'id', width: 60 },
      { text: 'User', value: 'user_id', width: 80 },
      { text: 'Action', value: 'action' },
      { text: 'Resource', value: 'resource' },
      { text: 'Effect', value: 'effect', width: 90 },
      { text: 'Priority', value: 'priority', width: 90 },
      { text: 'Condition', value: 'condition' },
      { text: 'Azioni', value: 'actions', sortable: false, width: 160 }
    ],
    policies: [],
    form: { id: null, user_id: null, action: 'view', resource: '', effect: 'allow', priority: 100, condition: null },
    conditionJSON: '',
    valid: true,
    test: { action: 'view', resource: 'candidato' },
    testAttrsJSON: '{"fase":"formazione","lista":"attivazione"}',
    testResult: null
  }),
  computed: {
    ...mapState('acl', ['version'])
  },
  mounted() {
    this.fetch();
  },
  methods: {
    pretty(obj) { return obj ? JSON.stringify(obj, null, 2) : ''; },
    async fetch() {
      const res = await axios.get('/auth/me/permissions');
      this.policies = res.data.policies || [];
      // aggiorna cache globale
      this.$store.commit('acl/SET_ACL', res.data);
    },
    newPolicy() {
      this.form = { id: null, user_id: null, action: 'view', resource: '', effect: 'allow', priority: 100, condition: null };
      this.conditionJSON = '';
    },
    edit(item) {
      this.form = { ...item, user_id: item.user_id };
      this.conditionJSON = item.condition ? JSON.stringify(item.condition, null, 2) : '';
    },
    reset() {
      this.newPolicy();
    },
    async save() {
      try {
        const cond = this.conditionJSON ? JSON.parse(this.conditionJSON) : null;
        const payload = { ...this.form, condition: cond };
        if (this.form.id) {
          await window.axios.put(`/acl/policies/${this.form.id}`, payload);
        } else {
          const res = await window.axios.post('/acl/policies', payload);
          this.form.id = res.data.id;
        }
        await this.fetch();
        this.$emit('snack','Salvato');
      } catch(e) {
        console.error(e);
        alert('JSON condition non valido o errore salvataggio.');
      }
    },
    async remove(item) {
      if (!confirm('Eliminare la policy?')) return;
      await window.axios.delete(`/acl/policies/${item.id}`);
      await this.fetch();
    },
    runTest() {
      try {
        const attrs = this.testAttrsJSON ? JSON.parse(this.testAttrsJSON) : {};
        this.testResult = evaluate(this.policies, {
          action: this.test.action,
          resource: this.test.resource,
          attrs
        });
      } catch (e) {
        alert('Attrs JSON non valido');
        this.testResult = null;
      }
    }
  }
};
</script>
